/** Capacidades de plan expuestas en GET /menu (business.plan_capabilities). */

export const MENU_CHECKOUT_BLOCKED_MESSAGE =
  'Este local solo muestra su carta digital. Para recibir pedidos activá el plan Starter o superior.';

export function normalizePublicMenuPlanId(business) {
  const raw = String(
    business?.active_plan || business?.plan || business?.membership_plan || '',
  )
    .trim()
    .toLowerCase();
  if (raw === 'emprendedor') return 'starter';
  if (raw === 'profesional') return 'pro';
  return raw || null;
}

export function getMenuPlanCapabilities(business) {
  const caps = business?.plan_capabilities;
  return caps && typeof caps === 'object' ? caps : null;
}

export function hasMenuPlanCapability(business, key) {
  const capKey = String(key || '').trim();
  const caps = getMenuPlanCapabilities(business);
  if (caps && Object.prototype.hasOwnProperty.call(caps, capKey)) {
    return Boolean(caps[capKey]);
  }
  const planId = normalizePublicMenuPlanId(business);
  if (planId === 'menu') {
    return capKey === 'public_menu';
  }
  return true;
}

export function canShowPublicOrders(business) {
  return hasMenuPlanCapability(business, 'orders');
}

export function canShowPublicAssistant(business) {
  return hasMenuPlanCapability(business, 'assistant');
}

export function canShowAdvancedPromos(business) {
  return hasMenuPlanCapability(business, 'advanced_promos');
}

export function shouldShowSoluqrBranding(business) {
  return !hasMenuPlanCapability(business, 'branding_removal');
}

/** Carrito / checkout / register-order deshabilitados (plan Menú o fallback técnico). */
export function isPublicMenuCheckoutDisabled(business, menuMeta = null) {
  if (menuMeta?.fallback_mode || menuMeta?.fallback_checkout_disabled) return true;
  return !canShowPublicOrders(business);
}
